import { render, staticRenderFns } from "./in-a-row.vue?vue&type=template&id=0f5fb901&"
import script from "./in-a-row.vue?vue&type=script&lang=js&"
export * from "./in-a-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports